// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "41b9566cb0f13635743f28084e4e598e442e5dcb/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};